import { apiFetch } from './http';

export interface AuditEntry {
  auditId: string;
  timestamp: string;
  action: string;
  actor: string;
  tenantId: string | null;
  productId: string | null;
  resourceType: 'tenant' | 'deployment' | 'version' | 'system';
  detail: Record<string, unknown>;
}


export async function fetchAuditLog(): Promise<{ entries: AuditEntry[] }> {
  return apiFetch('/ops/audit');
}

export async function fetchTenantAuditLog(tenantId: string): Promise<{ entries: AuditEntry[] }> {
  return apiFetch(`/ops/audit/tenant/${tenantId}`);
}
